import { gql, useQuery } from '@apollo/client';

export const GET_QUESTIONNAIRES_BY_MEMBER_ID = gql`
  query getEmployeeQuestionnaireByMemberId($id: String!) {
    getEmployeeQuestionnaireByMemberId(id: $id) {
      _id
      companyId
      jobId
      jobCompanyId
      jobLocationId
      departmentId
      jobLocation {
        companyBusinessAddressId
        companyDepartmentId
        companyLocationId
        jobId
      }
    }
  }
`;

export const useGetEmployeeQuestionnaireByMemberId = (id: string) => {
  const { data = {}, loading } = useQuery(GET_QUESTIONNAIRES_BY_MEMBER_ID, {
    variables: { id },
    skip: !id,
  });

  const employeeQuestionnaire = data?.getEmployeeQuestionnaireByMemberId || {};

  return { employeeQuestionnaire, loading };
};
